import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

export var TYPE = {
  date: "date",
  acknowledge: "acknowledge",
};

var requestSchema = yup.object({
  ids: yup.array().of(yup.number()).required(),
  type: yup.string().required(),
  patientId: yup.number().required(),
});

export function usePatientDocumentsExpirationDateRemoveMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.patientDocuments.bulkExpirationRemove(), {
        document_ids: req.ids,
        remove_type: req.type,
        patient_id: req.patientId,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.all],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
